module.exports = {
  stringify: function stringify(queryObj) {
    var qstring = '';

    for (var key in queryObj) {
      var value = queryObj[key];
      if (value) qstring += "&".concat(key, "=").concat(value);
    }

    qstring = qstring.slice(1); // encodeURI should be accessible in a browser environment
    // otherwise if neither node.js querystring nor encodeURI
    // are accessible, just return the string

    if (encodeURI) return encodeURI(qstring);
    return qstring;
  }
};